module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA6ElEQVR4Ad2QJVSFURCEB3eHhLvTcJeGW8KhIAmHiETcesK14DQa0khEnN4Hnuz5y5MLBfnOuX53d2bxOyh0cOexVwRvfWK+NCDsToPJIbYccA3g9XcSdNWDL2fgdB+Y5uXMNc9Q5QQCvdzBlVHw/QLsrgebXX146R2lnmC8C2yrABMiwKMl8G7bkBSwMAQJ1q3y2FwG8tbygIaWICoY1DX1/gAM8FFToIPuruBkj6EHfY2gY0kQMVNALBebH0JHFfh4bGiib7w7MZwmn9QS6JqWEGdH1EQTi0XyQT0BUvyJiWx5UB//gw+KJBY2eMkyZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/VU.png
// module id = 1301
// module chunks = 0